import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Calendar, Video } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Live() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/live-sessions").then((r) => setItems(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="live-page">
      <div>
        <p className="text-xs uppercase tracking-[0.25em] text-gold font-semibold">Live Classes</p>
        <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-2">Upcoming sessions</h1>
        <p className="text-muted-foreground mt-2">Join live cohorts with Prerna Maheshwari.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {items.map((s) => {
          const d = new Date(s.starts_at);
          return (
            <div key={s.id} className="rounded-3xl bg-card border border-border p-6 card-hover">
              <div className="flex items-start gap-4">
                <div className="h-14 w-14 rounded-2xl royal-gradient text-white flex flex-col items-center justify-center text-xs">
                  <span className="font-bold">{d.toLocaleString('en', { month: 'short' })}</span>
                  <span className="font-display text-lg font-bold leading-none">{d.getDate()}</span>
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-xl font-bold">{s.title}</h3>
                  <p className="text-sm text-muted-foreground mt-1">by {s.trainer}</p>
                  <p className="text-xs text-muted-foreground mt-2 flex items-center gap-1">
                    <Calendar className="h-3 w-3" /> {d.toLocaleString([], { dateStyle: "medium", timeStyle: "short" })}
                  </p>
                </div>
              </div>
              <a href={s.zoom_link} target="_blank" rel="noreferrer" data-testid={`join-live-${s.id}`}>
                <Button className="mt-4 w-full rounded-full royal-gradient border-0 text-white btn-lift">
                  <Video className="h-4 w-4 mr-1.5" /> Join live
                </Button>
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
}
